import { isPlatformServer } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	OnInit,
	Optional,
	PLATFORM_ID,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { RESPONSE } from '@uc/shared/authentication';
import { PageNotFoundImgSvgComponent } from '@uc/shared/svg';
import { Response } from 'express';

@Component({
	selector: 'uc-not-found',
	templateUrl: './not-found.component.html',
	imports: [RouterLink, PageNotFoundImgSvgComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent implements OnInit {
	currentYear = new Date().getFullYear();

	constructor(
		@Inject(PLATFORM_ID) private _platformId: object,
		@Optional() @Inject(RESPONSE) private _response: Response,
	) {}

	ngOnInit() {
		if (isPlatformServer(this._platformId)) {
			this._response?.status(404);
		}
	}
}
